import React, { ReactNode } from 'react';
import useDate from '~/react-hooks/use-date';
import { Box } from '../Common/Box';

export interface UpcomingBillProps {
  upcomingBill?: ReactNode;
  billingDate?: string | null;
}

export function UpcomingBill({ billingDate, upcomingBill }: UpcomingBillProps) {
  const billingDateTime = useDate(billingDate);
  return (
    <Box className='w-full flex flex-col w-full'>
      <div className='w-full flex flex-col xmd:flex-row items-center gap-y-4 gap-x-4'>
        <div className='w-full xmd:w-2/5 flex flex-col items-end xmd:items-start'></div>
        <div className='w-full xmd:w-2/5 flex justify-end xmd:justify-start'>
          {billingDate && (
            <div className='flex flex-row gap-x-8 items-center flex-wrap v2-text-neutral-900'>
              <span className='text-base font-bold '>Next billing date</span>
              <span className='text-[21px]'>
                {billingDateTime.local?.toFormat('DD')}
              </span>
            </div>
          )}
        </div>
        <div className='w-full xmd:w-1/5 flex flex-row justify-end'>
          <div className='flex flex-row gap-x-8 flex-wrap items-center v2-text-neutral-900'>
            <span className='text-base font-bold'>Total</span>
            <span className='text-[28px]'>{upcomingBill}</span>
          </div>
        </div>
      </div>
    </Box>
  );
}
